import { render, staticRenderFns } from "./yesEditor.vue?vue&type=template&id=b7840a48&scoped=true"
import script from "./yesEditor.vue?vue&type=script&lang=js"
export * from "./yesEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7840a48",
  null
  
)

export default component.exports